angular.module('Itao.IndicatorMap').directive('stackedBar', function (d3, mapConfig) {
  'use strict';

  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;

  var stackedSetBarChart = function () {
    var colors = [];
    var stackHeader = '';
    var barWidth = 80;
    var duration = 400,
      numberFormat = germanNumberFormat(',.1f');

    var chart = function (selection) {
      selection.each(function (data) {
        // reverse data to sort indicators from bottom to top
        data.reverse();
        var container = d3.select(this).datum([data]).classed('education-participation', true);
        var heightFactor = 2;
        var prevHeight = [0];
        var total = 0;
        var svgMarginTop = 20;
        // Total and stackHeights
        data.forEach(function (value, i) {
          if (value != null) {
            total += value;
            prevHeight.push(prevHeight[i] + value);
          } else {
            prevHeight.push(prevHeight[i]);
          }
        });

        var marginTop = 100 - total + svgMarginTop;
        var svgWidth = 150,
          svgHeight = (total * heightFactor) + (marginTop * heightFactor);
        prevHeight = prevHeight.map(function (height) {
          return height + marginTop;
        });

        var svg = container.selectAll('svg').data([data]);
        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var stack = svg.selectAll('g').data([data]);
        // svg.selectAll('.margin-group').attr('transform', 'translate(' + (svgWidth/2) + ',' + (svgHeight/2) + ')');

        var stackEnter = stack.enter()
          .append('g')
          .attr('class', 'margin-group');

        var bars = stack.selectAll('rect')
          .data(data);

        var barsEnter = bars
          .enter()
          .append('rect')
          .attr('width', barWidth);

        bars
          .transition()
          .duration(duration)
          .attr('height', function (d) {
            return d * heightFactor;
          })
          .attr('y', function (d, i) {
            return prevHeight[i] * heightFactor;
          })
          .attr('x', 0)
          .attr('width', barWidth)
          .attr("fill", function (d, i) {
            return colors[i];
          });

        var rectLabels = stack.selectAll(".rectLabel")
          .data(function (d) {
            return d;
          });

        var rectLabelsEnter = rectLabels
          .enter().append("text")
          .attr("class", "rectLabel")
          .attr("alignment-baseline", "middle")
          .attr("fill", "#000000");

        rectLabels
          .transition()
          .duration(duration)
          .text(function (d, i) {
            if (d != null) {
              return numberFormat(d);
            } else {
              return '';
            }
          })
          .attr("x", function (d) {
            return barWidth + 10;
          })
          .attr("y", function (d, i) {
            var dataHeight = d * heightFactor;
            var pHeight = prevHeight[i] * heightFactor;
            var y = (pHeight + dataHeight) - (dataHeight / 2);
            return y < 235 ? y : 235;
          });

        // Top List sum
        var topValue = svg
          .selectAll(".barSum")
          .data([data]);

        var topValueEnter = topValue
          .enter()
          .append("text")
          .attr("class", function () {
            if (stackHeader) {
              return "barSum stack-header";
            } else {
              return "barSum";
            }
          })
          .attr("text-anchor", "middle")
          .attr("fill", "#000000");

        topValue.transition().duration(duration)
          .attr("x", function (d, i) {
            return barWidth / 2;
          })
          .attr("y", function (d, i) {
            return marginTop * heightFactor - 10;
          })
          .text(function (d, i) {
            if (!total) return '—';
            if (stackHeader) {
              return stackHeader;
            } else {
              return numberFormat(total);
            }
          });

        // Sonderfall leerer stack - Überschrift soll stehen bleiben
        if (!total && stackHeader) {
          // Top List sum
          var emptyStackHeader = svg
            .selectAll(".empty")
            .data([data]);

          var emptyStackHeaderEnter = emptyStackHeader
            .enter()
            .append("text")
            .attr("class", 'empty')
            .attr("text-anchor", "middle")
            .attr("fill", "#000000");

          emptyStackHeader.transition().duration(duration)
            .attr("x", function (d, i) {
              return barWidth / 2;
            })
            .attr("y", 30) // y on 100%
            .text(stackHeader);

          emptyStackHeader.exit().transition().duration(duration)
            .attr('width', 0)
            .attr('height', 0)
            .remove();
        } else {
          svg.selectAll(".empty").remove();
        }

        rectLabels.exit().transition().duration(duration)
          .attr('width', 0)
          .attr('height', 0)
          .remove();

        topValue.exit().transition().duration(duration)
          .attr('width', 0)
          .attr('height', 0)
          .remove();

        bars.exit().transition().duration(duration)
          .attr('width', 0)
          .attr('height', 0)
          .remove();
      });
    };

    /**
     * getter/setter for colors
     * @param {Function} [newColorSet] new color function
     * @returns {*}
     */
    chart.colors = function (newColorSet) {
      if (!arguments.length) {
        return colors;
      } else {
        colors = newColorSet;
        return chart;
      }
    };

    /**
     * getter/setter for colors
     * @param {Function} [newStackHeader] new color function
     * @returns {*}
     */
    chart.stackHeader = function (newStackHeader) {
      if (!arguments.length) {
        return stackHeader;
      } else {
        stackHeader = newStackHeader;
        return chart;
      }
    };

    return chart;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'districtReport/stackedBar.html',
    scope: {
      selectedDataLayer: "=",
      selectedDistrict: "=",
      stackIndicatorIds: "=",
      colors: "=",
      stackBlank: "=",
      stackHeader: "="
    },
    link: function (scope, element) {
      var stackedSetBarChartFunction = stackedSetBarChart();

      /**
       * update the chart from one of the watchers
       */
      var rerender = function () {
        var chartColors = scope.colors ? scope.colors : ["#ff6600", "#ffb380", "#003399", "#80afff", "#ffcc00", "#ffe680", "#339933", "#9fdf9f"];
        if (!scope.selectedDistrict || !scope.selectedDataLayer || angular.equals(scope.selectedDataLayer, {})) {
          d3.select(element[0]).select('svg').remove();
          return;
        }
        var data = [];
        scope.stackIndicatorIds.forEach(function (id) {
          var value = scope.selectedDataLayer[scope.selectedDistrict.uid] ? scope.selectedDataLayer[scope.selectedDistrict.uid][id] : null;
          if (value) {
            data.push(value);
          } else {
            data.push(null);
          }
        });
        if(scope.stackBlank && scope.stackIndicatorIds.length === 1 && data[0] !== null) {
          data.push(100 - data[0]);
        }

        // set colorSet
        stackedSetBarChartFunction
          .colors(chartColors)
          .stackHeader(scope.stackHeader);

        d3.select(element.find('.widget-inner:first')[0])
          .data([data])
          .call(stackedSetBarChartFunction);
      };

      var layerWatcher = scope.$watch('selectedDataLayer', rerender);
      var indicatorSetsWatcher = scope.$watchCollection('indicatorSets', rerender);
      var districtWatcher = scope.$watch('selectedDistrict', rerender);

      // remove watcher on destroy
      element.on('$destroy', function () {
        layerWatcher();
        districtWatcher();
        indicatorSetsWatcher();
      });
    }
  };
});
